export const GET_MY_ORDERS = "GET_MY_ORDERS";
export const GET_MY_ORDERS_SUCCESS = "GET_MY_ORDERS_SUCCESS";
export const GET_MY_ORDERS_FAIL = "GET_MY_ORDERS_FAIL";

